import { DetailedSummaryReportActionTypes } from 'src/store/actions/detailedSummaryReportAction';
import DetailedSummaryReportParser from 'src/helpers/modular/detailedSummaryReport/parser';
export const initialState = {
    rawReport: {},
    parsedReport: {},
    uiConfig: {
        showTimeSpan: false
    },
    loading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case DetailedSummaryReportActionTypes.SAVE_DETAILED_SUMMARY_REPORT:
            return {
                ...state,
                rawReport: payload.rawReport,
                parsedReport: DetailedSummaryReportParser.parse(payload),
                loading: false
            };
        case DetailedSummaryReportActionTypes.LOADING_DETAILED_SUMMARY_REPORT:
            return {
                ...state,
                loading: true
            };
        case DetailedSummaryReportActionTypes.NOT_LOADING_DETAILED_SUMMARY_REPORT:
            return {
                ...state,
                loading: false
            };
        case DetailedSummaryReportActionTypes.UPDATE_DETAILED_SUMMARY_REPORT_UI_CONFIG:
            return {
                ...state,
                uiConfig: {
                    ...state.uiConfig,
                    ...payload
                }
            };
        default:
            return state;
    }
};
